import {
  Divider,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
} from "@nextui-org/react";
import React from "react";

import DrawerBody from "./DrawerBody";
import DrawerHeader from "./DrawerHeader";

/**
 * UserDrawer Component
 * Right-side drawer modal for displaying detailed user information
 * Shows user details, permissions, and contribution statistics
 * @param {Object} props - Component props
 * @param {Object} props.User - User object containing user information
 * @param {string} props.OrgInfo - Organization ID for the current context
 * @param {boolean} props.isOpen - Whether the drawer is open
 * @param {Function} props.onOpenChange - Function to handle drawer open/close state
 * @returns {JSX.Element} User details drawer modal
 */
const UserDrawer = ({ User, OrgInfo, isOpen, onOpenChange }) => {
  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      className="absolute top-0 right-0 !m-0 h-screen z-100"
      backdrop="transparent"
      hideCloseButton={true}
    >
      <ModalContent>
        {(onClose) => (
          <>
            {/* Drawer Header with User Info */}
            <ModalHeader className="flex flex-col items-center">
              <DrawerHeader User={User} onOpenChange={onOpenChange} />
              <Divider className="mt-2" />
            </ModalHeader>
            
            {/* Drawer Body with User Details */}
            <ModalBody className="gap-0">
              <DrawerBody User={User} OrgInfo={OrgInfo} />
            </ModalBody>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};

export default UserDrawer;
